import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { PricingStudioScreen } from './-components/pricing-studio-screen.tsx'

/**
 * `?dealId=` carries the HubSpot deal, so a link on the deal record opens the studio
 * already pointed at it. Saving needs the id and nothing else asks HubSpot for anything,
 * which is what keeps this page free of a HubSpot credential.
 *
 * @param search - The raw search params.
 * @returns The deal id, when one was given.
 */
function validateSearch(search: Record<string, unknown>): { dealId?: string } {
  const dealId = search['dealId']

  // A HubSpot deal id is all digits, and the router JSON-parses search values, so
  // `?dealId=27736888` arrives as a number rather than a string. Rejecting that would
  // drop every real link; coerce it instead, and keep it a string from here on because
  // an id is a label, not a quantity.
  if (typeof dealId === 'number' && Number.isFinite(dealId)) {
    return { dealId: String(dealId) }
  }

  return typeof dealId === 'string' && dealId.trim() !== ''
    ? { dealId: dealId.trim() }
    : {}
}

function PricingStudioPage(): JSX.Element {
  const { dealId } = Route.useSearch()

  return <PricingStudioScreen dealId={dealId} />
}

export const Route = createFileRoute('/sales-tools/pricing-studio')({
  validateSearch,
  component: PricingStudioPage
})
